<template>
  <data-form
    :entity="formValue"
    :fields="fields"
    model="switches"
    :buttons="buttons"
    :cancel="false"
  />
</template>

<script>
const switchTypes = ['garage', 'gate', 'light', 'switch']
const switchModes = ['online', 'offline', 'anti-pb', 'learning']

export default {
  name: 'switch-form',
  props: {
    switchx: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      fields: {
        'name': {
          rules: [{ required: true, max: 12 }]
        },
        'type': {
          type: 'select',
          rules: [{ required: true, type: 'number' }],
          options: switchTypes.map((t, i) => ({ label: 'switchType.' + t, value: i + 1 }))
        },
        'pausetime': {
          type: 'number',
          rules: [{ type: 'number', required: true }]
        },
        'autoclosetime': {
          type: 'number',
          rules: [{ type: 'number', required: true }]
        },
        'mode': {
          type: 'select',
          rules: [{ required: true }],
          options: switchModes.map((t) => ({ label: 'switchMode.' + t, value: t }))
        },
        'systemForm': {
          type: 'hidden'
        }
      },
      buttons: [
        {
          label: 'submit-scheduled',
          submit: true,
          icon: 'time',
          type: 'success',
          params: {
            scheduled: true
          }
        },
        {
          label: 'submit',
          icon: 'circle-check',
          submit: true,
          params: {
            scheduled: false
          }
        }
      ]
    }
  },
  computed: {
    formValue () {
      return { ...this.switchx, 'systemForm': 0 }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SwitchForm.vue?f24beb02